import { Typography, TypographyProps } from "@tvg/fuse/typography";
import React, { PropsWithChildren } from "react";
import styles from "./Heading.module.css";

export interface HeadingProps extends TypographyProps {}

const Heading = ({ className, ...props }: PropsWithChildren<HeadingProps>) => (
  <Typography
    dataTestId="results-heading"
    className={!className ? styles.heading : `${styles.heading} ${className}`}
    tag="h1"
    size={{
      xxs: "3",
      m: "4",
      l: "6",
    }}
    {...props}
  />
);

export default React.memo(Heading);
